import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fileExtension' })
export class FileExtensionPipe implements PipeTransform {

  transform(fileUrl: string): string {
    return fileUrl?.split('.').pop()?.toUpperCase() || '';
  }
}
